import script from "./TextureProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./TextureProjects.vue?vue&type=script&setup=true&lang=js"

import "./TextureProjects.vue?vue&type=style&index=0&id=320089e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-320089e6"]])

export default __exports__